import scrollSmooth from 'scroll-smooth'

// import SmoothScroll from 'smooth-scroll';

// Main page paths for production and development
const mainPaths = ['/static/app/', '/app/', '/']

window.addEventListener('load', () => {
  window.scrollTo(0, 0)
  const hash = window.location.hash

  if (hash) {
    setTimeout(() => {
      let anchor = document.querySelector(hash)

      if (hash === '#locals') {
        anchor = document.querySelector('[data-id="locals"]')
      }

      if (anchor && window.fScrollToElement) {
        window.fScrollToElement(
          anchor,
          true,
          false,
          hash === '#locals' ? { desktop: -200, mobile: -100 } : null,
        )
      }
    }, 100)
  }

  const links = document.querySelectorAll('a[href^="/#"], a[href^="#"]')

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      let anchor: Element | null = null

      const header = document.querySelector('[data-item="web-header"].isOpen')

      if (header) {
        header.classList.remove('isOpen')
      }

      //   if (mainPaths.includes(window.location.pathname)) {

      anchor = document.querySelector(
        `#${(link.getAttribute('href') as string).split('#')[1]}`,
      )
      //   }
      // let anchor = document.querySelector(link.getAttribute('href').replace('/', ''));

      // // Check if user is on main page
      // if (mainPaths.includes(window.location.pathname)) {
      //   anchor = document.querySelector(link.getAttribute('href').replace('/', ''));
      // }

      if (anchor) {
        event.preventDefault()

        setTimeout(() => {
          if (window.fScrollToElement)
            window.fScrollToElement(anchor as Element)
        }, 700)
      }
    })
  })
})

// Scroll to element on custom  event
window.addEventListener('bw-scroll-to-element', (e: Event) => {
  // Get element to scroll to
  const target = (e as CustomEvent).detail.target

  if (target && window.fScrollToElement) {
    window.fScrollToElement(target)
  }
})

/**
 *
 * @param {htmlElement} element - element to which page should scroll
 * @param {bool} updateURL - if url should be updated with #target after scroll
 * Pin function to window, so it may be used anywhere
 */
window.fScrollToElement = (
  element,
  updateUrl = true,
  constOffset = false,
  customOffset,
) => {
  return new Promise((resolve, reject) => {
    if (element) {
      // let scroll = new SmoothScroll();

      // Add listener to return callback when scroll stops
      const listener = () => {
        document.removeEventListener('scrollStop', listener, false)

        resolve('scroll finished')
      }

      document.addEventListener('scrollStop', listener, false)

      let offset = -120

      if (window.innerWidth <= 1200) {
        offset = 130
      }

      if (customOffset) {
        offset = customOffset.desktop

        if (window.innerWidth <= 1200) {
          offset = customOffset.mobile
        }
      }

      // Animate to element with given options
      scrollSmooth.to(element, {
        duration: 0,
        offset: offset,
      })
    }
  })
}
